import {Grid} from "@mui/material";
import {PhonePrefixSelect, TextField} from "@variocube/app-ui";
import {parsePhoneNumberWithError} from "libphonenumber-js";
import React, {useEffect, useState} from "react";
import {useLocalization} from "../i18n";
import {notBlank} from "../utils";

interface PhoneInputProps {
	defaultCountry?: string;
	phoneNumber?: string;
	onChange?: (normalizedNumber?: string) => void;
	error?: boolean;
	helperText?: string;
}

export function PhoneInput({defaultCountry, phoneNumber, onChange, error, helperText}: PhoneInputProps) {
	const {t} = useLocalization();

	const [prefix, setPrefix] = useState<string | null>(defaultCountry ?? "43");
	const [number, setNumber] = useState("");

	useEffect(() => {
		if (notBlank(phoneNumber)) {
			try {
				const phone = parsePhoneNumberWithError(phoneNumber as string);
				setPrefix(phone.countryCallingCode ?? null);
				setNumber(phone.nationalNumber);
			}
			catch (err) {
				console.error("Failed to parsed number on initial", err);
			}
		}
	}, []);

	function handleOnChange(phonePrefix: string | null, phoneNumber: string) {
		if (onChange) {
			if (!phonePrefix || !phoneNumber) {
				onChange(undefined);
			}
			else {
				try {
					const phone = parsePhoneNumberWithError(phoneNumber, {defaultCallingCode: phonePrefix});
					onChange(phone.number);
				}
				catch (err) {
					console.error("Failed to parsed phone number on change", err);
				}
			}
		}
	}

	function handlePrefixChange(phonePrefix: string | null) {
		setPrefix(phonePrefix);
		handleOnChange(phonePrefix, number);
	}

	function handleNumberChange(phoneNumber: string) {
		const parsedNumber = phoneNumber.replace(/[^\d]/g, "");
		setNumber(parsedNumber);
		handleOnChange(prefix, parsedNumber);
	}

	return (
		<Grid container spacing={2}>
			<Grid item sm={5} xs={6}>
				<PhonePrefixSelect
					label={t("customer.phonePrefix")}
					value={prefix}
					onChange={handlePrefixChange}
				/>
			</Grid>
			<Grid item sm={7} xs={6}>
				<TextField
					fullWidth
					label={t("customer.phone")}
					value={number}
					onChange={handleNumberChange}
					error={error}
					helperText={helperText}
				/>
			</Grid>
		</Grid>
	);
}
